export const SOME_ACTION = 'SOME_ACTION';
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const PRESENTATION_MODE ='PRESENTATION_MODE';
export const NIGHT_MODE = 'NIGHT_MODE';
export const TOGGLE_HEADER_EXPAND = 'TOGGLE_HEADER_EXPAND';
export const LOGIN_RETURN = "LOGIN_RETURN";
export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";
export const POST_NO_RETURN="POST_NO_RETURN";
export const PAGE_LOADING = "PAGE_LOADING";
export const PAGE_LOADED = "PAGE_LOADED";
//MOCKING
export const INIT_MOCK="INIT_MOCK";
export const DISPLAY_APP_LOG="DISPLAY_APP_LOG";
export const UPDATE_TASKS="UPDATE_TASKS";
//LOGGIN
export const TOGGLE_CONNECT = 'TOGGLE_CONNECT';
export const LOG_USER = 'LOG_USER';
export const DISCONNECT = 'DISCONNECT';
export const UPDATE_SESSION = 'UPDATE_SESSION';

// NAVIGATION
export const SWITCH_VIEW = 'SWITCH_VIEW';
export const UPDATE_APP_STRUCTURE = 'UPDATE_APP_STRUCTURE';
export const UPDATE_CLIENTS_LIST = 'UPDATE_CLIENTS_LIST';
export const UPDATE_SUBLEVEL = 'UPDATE_SUBLEVEL';

//GENERIC MODULE 
export const UPDATE_MODULE_EXPAND = 'UPDATE_MODULE_EXPAND';
export const REGISTER_MODULE = 'REGISTER_MODULE';
export const MODULE_ADD_DATA = 'MODULE_ADD_DATA';
export const MODULE_UPDATE_DATA = 'MODULE_UPDATE_DATA';

//API
export const OPEN_SESSION_RETURN = 'OPEN_SESSION_RETURN';
export const POST_N3_RETURN = 'POST_N3_RETURN';
export const  POST_TDI_RETURN = 'POST_TDI_RETURN';

// GENERIC CALL
export const POST_RETURN = 'POST_RETURN';
export const GET_OBJECTS_RETURN = 'GET_OBJECTS_RETURN';
export const GET_LIST_OPTIONS_RETURN = 'GET_LIST_OPTIONS_RETURN';
export const GET_OBJECT_RETURN = 'GET_OBJECT_RETURN';
export const SAVE_OBJECT_RETURN = 'SAVE_OBJECT_RETURN';
export const CLEAN_LOADED_OBJECT = 'CLEAN_LOADED_OBJECT';
export const SET_CURRENT_NODE = 'SET_CURRENT_NODE';


// FORM
export const UPDATE_FROM_FORM = 'UPDATE_FROM_FORM';
export const CLOSE_FORM = 'CLOSE_FORM';

// PAGINATION
export const RESET_PAGINATION = 'RESET_PAGINATION';
export const ADD_PAGE = 'ADD_PAGE';
export const NO_MORE_RECORD = 'NO_MORE_RECORD';
